module.exports = __webpack_public_path__ + "static/media/BebasNeue-Pro-Bold.4e9d1b62.otf";